export default __webpack_public_path__ + "static/media/ProzesssimpleToolbox.2cf06134.png";